export var DEFAULT_LOCALE = 'en';
export var LOCALE_COOKIE = 'userLocale';
export var LOCALE_LABELS = {
  'en-US': 'English',
  en: 'English',
  nl: 'Nederlands',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  it: 'Italiano',
  pt: 'Português',
  ja: '日本語',
  // Japanese
  ru: 'Русский'
};